import { useState } from "react";

const C = {
  navy:"#0B1F3A",blue:"#1560BD",blueMid:"#1A73E8",blueLight:"#E8F0FE",
  teal:"#0D7A5F",tealLight:"#E0F4EE",amber:"#B45309",amberLight:"#FEF3C7",
  red:"#B91C1C",redLight:"#FEE2E2",ink:"#0F172A",inkMid:"#334155",inkLight:"#64748B",
  border:"#E2E8F0",surface:"#F8FAFC",white:"#FFFFFF",
  green:"#166534",greenLight:"#DCFCE7",purple:"#5B21B6",purpleLight:"#EDE9FE",
};

const S = {
  app:{ fontFamily:"'DM Sans',system-ui,sans-serif", background:C.surface, minHeight:"100vh", color:C.ink },
  card:{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, overflow:"hidden", marginBottom:16 },
  cardHdr:{ padding:"13px 18px", borderBottom:`1px solid ${C.border}`, display:"flex", alignItems:"center", justifyContent:"space-between" },
  cardTitle:{ fontSize:13, fontWeight:600, color:C.ink },
  content:{ padding:24 },
  fg:{ marginBottom:14 },
  label:{ display:"block", fontSize:12, fontWeight:500, color:C.inkMid, marginBottom:5 },
  input:{ width:"100%", padding:"9px 12px", border:`1px solid ${C.border}`, borderRadius:8, fontSize:13, color:C.ink, background:C.white, outline:"none", boxSizing:"border-box" },
  select:{ width:"100%", padding:"9px 12px", border:`1px solid ${C.border}`, borderRadius:8, fontSize:13, color:C.ink, background:C.white, outline:"none", boxSizing:"border-box" },
  textarea:{ width:"100%", padding:"9px 12px", border:`1px solid ${C.border}`, borderRadius:8, fontSize:13, color:C.ink, background:C.white, outline:"none", boxSizing:"border-box", resize:"vertical", minHeight:72 },
  btnPrimary:{ background:C.blue, color:C.white, border:"none", padding:"10px 20px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer" },
  btnSecondary:{ background:"transparent", color:C.ink, border:`1px solid ${C.border}`, padding:"9px 16px", borderRadius:8, fontSize:13, cursor:"pointer" },
  btnSmall:{ background:C.blueLight, color:C.blue, border:"none", padding:"5px 11px", borderRadius:6, fontSize:11, fontWeight:500, cursor:"pointer" },
  btnDanger:{ background:C.redLight, color:C.red, border:"none", padding:"5px 11px", borderRadius:6, fontSize:11, fontWeight:500, cursor:"pointer" },
  btnSuccess:{ background:C.greenLight, color:C.green, border:"none", padding:"5px 11px", borderRadius:6, fontSize:11, fontWeight:500, cursor:"pointer" },
  btnGhost:{ background:"none", border:"none", color:C.blue, fontSize:12, cursor:"pointer", padding:0 },
  pillGreen:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.greenLight, color:C.green },
  pillAmber:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.amberLight, color:C.amber },
  pillRed:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.redLight, color:C.red },
  pillBlue:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.blueLight, color:C.blue },
  pillPurple:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.purpleLight, color:C.purple },
  twoCol:{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 },
};

// """ CERTIFICATION DATA """""""""""""""""""""""""""""""""""""""""""""""""""""""
let certCounter = 1;
const genCertNum = (track) => {
  const prefix = track==="tech" ? "MPC-TECH" : "MPC-SA";
  const num = String(certCounter++).padStart(5,"0");
  return `${prefix}-2025-${num}`;
};

const INIT_CERT_VIDEOS = [
  {
    id:1, title:"Catalytic converter cleaner -product mastery", track:"tech",
    duration:"8 min", required:true, active:true,
    desc:"Full application guide, P0420/P0430 diagnosis, demo technique for repair shops.",
    questions:[
      {id:1,q:"What OBD codes does the catalytic converter cleaner address?",opts:["P0300, P0301","P0420, P0430","P0171, P0174","P0500, P0505"],answer:1},
      {id:2,q:"How should the product be applied for best results?",opts:["Mix with oil","Add to empty tank","Add to nearly empty fuel tank then fill up","Spray directly on converter"],answer:2},
      {id:3,q:"At what driving condition does the converter self-clean?",opts:["At idle","At highway speeds for 15+ minutes","During cold start","In reverse"],answer:1},
      {id:4,q:"What percentage of P0420 cases are caused by contamination vs actual converter failure?",opts:["10%","25%","40%","60%"],answer:2},
      {id:5,q:"What product should always be paired with the catalytic converter cleaner?",opts:["Oil flush","Fuel system cleaner","Radiator flush","Power steering fluid"],answer:1},
    ]
  },
  {
    id:2, title:"DPF product line -complete system", track:"tech",
    duration:"12 min", required:true, active:true,
    desc:"DPF purge filter, foam cleaner, and flush liquid -applications, diagnosis, and demo.",
    questions:[
      {id:1,q:"Which product is used for in-shop deep cleaning of a removed DPF?",opts:["DPF purge filter","DPF foam cleaner","DPF flush liquid","Diesel power cleaner"],answer:1},
      {id:2,q:"What is the typical cost of an OEM DPF replacement?",opts:["$200-400","$500-800","$1,500-4,000","$5,000+"],answer:2},
      {id:3,q:"How does the DPF purge filter work?",opts:["It is injected directly","It is added to fuel and burns off during regen","It requires machine application","It replaces the DPF"],answer:1},
      {id:4,q:"Which vehicles is the DPF product line compatible with?",opts:["Gas vehicles only","Diesel vehicles with DPF systems","All vehicles","Hybrid vehicles only"],answer:1},
      {id:5,q:"What is the recommended maintenance interval for DPF purge filter?",opts:["Every 1,000 miles","Every 5,000-10,000 miles","Every 50,000 miles","Only when light is on"],answer:1},
    ]
  },
  {
    id:3, title:"How to sell automotive maintenance products", track:"advisor",
    duration:"10 min", required:true, active:true,
    desc:"Opening scripts, value propositions, objection handling, and upsell techniques for service advisors.",
    questions:[
      {id:1,q:"What is the most effective opening question when a customer has a check engine light?",opts:["Can I help you?","When was the last time you had your fuel system cleaned?","Do you want to buy a cleaner?","Is your car under warranty?"],answer:1},
      {id:2,q:"When a customer says the product is too expensive, what is the best response?",opts:["Offer a discount","Compare to the cost of the repair it prevents","Apologize and move on","Suggest they buy online"],answer:1},
      {id:3,q:"What is the recommended upsell strategy for the catalytic converter cleaner?",opts:["Sell it alone","Pair with fuel system cleaner to address root cause","Offer the most expensive product","Suggest waiting to see if the light comes back"],answer:1},
      {id:4,q:"Which customer situation creates the strongest selling opportunity for DPF products?",opts:["Customer wants an oil change","Customer's DPF warning light is on","Customer bought a new vehicle","Customer is asking about tires"],answer:1},
      {id:5,q:"What is the key value proposition for the engine flush at oil change time?",opts:["It smells better","Fresh oil goes into clean passages instead of contaminated ones","It makes the oil darker","It replaces the need for an oil filter"],answer:1},
    ]
  },
  {
    id:4, title:"Service benefit key points -the full MPC line", track:"advisor",
    duration:"8 min", required:true, active:true,
    desc:"Product benefit summaries, revenue potential per service, and how to build recurring maintenance packages.",
    questions:[
      {id:1,q:"What is the shop revenue potential for an induction cleaning service?",opts:["$10-20","$30-50","$80-150","$300+"],answer:2},
      {id:2,q:"Which product combination creates the best premium oil change upsell?",opts:["Wiper blades + floor mats","Engine flush + anti-wear protection","Radiator flush + stop leak","Octane booster + fuel system cleaner"],answer:1},
      {id:3,q:"What is the recommended retail margin on MPC products?",opts:["10-20%","30-50%","75-100%","200%+"],answer:2},
      {id:4,q:"How should a service advisor position the DPF cleaning service ticket?",opts:["As a luxury add-on","As preventive maintenance cheaper than replacement","As an emergency repair","As optional"],answer:1},
      {id:5,q:"What is the best way to build recurring revenue with MPC products?",opts:["Sell once and forget","Create a maintenance schedule and remind customers at each visit","Only sell when customers ask","Offer the lowest price"],answer:1},
    ]
  },
];

const INIT_TECHNICIANS = [
  {id:1,shopId:1,name:"Carlos M.",role:"tech",email:"carlos@apexcarcare.com",status:"certified",certNum:"MPC-TECH-2025-00001",certDate:"Mar 20, 2025",score:100,track:"tech"},
  {id:2,shopId:1,name:"Tony R.",role:"tech",email:"tony@apexcarcare.com",status:"not_certified",certNum:"",certDate:"",score:0,track:"tech"},
  {id:3,shopId:1,name:"Sarah K.",role:"advisor",email:"sarah@apexcarcare.com",status:"certified",certNum:"MPC-SA-2025-00001",certDate:"Apr 1, 2025",score:80,track:"advisor"},
  {id:4,shopId:1,name:"Mike D.",role:"advisor",email:"mike@apexcarcare.com",status:"not_certified",certNum:"",certDate:"",score:0,track:"advisor"},
];

// """ CERTIFICATE DOCUMENT """""""""""""""""""""""""""""""""""""""""""""""""""""
function CertificateDoc({cert, onClose}) {
  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:3000,padding:20,overflowY:"auto"}}>
      <div style={{background:C.white,width:700,borderRadius:12,overflow:"hidden",maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{background:"#1E293B",padding:"12px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{color:C.white,fontSize:13,fontWeight:500}}>Certificate #{cert.certNum}</span>
          <div style={{display:"flex",gap:10}}>
            <button onClick={()=>window.print()} style={{background:"rgba(255,255,255,0.1)",border:"none",color:C.white,padding:"6px 14px",borderRadius:6,fontSize:12,cursor:"pointer"}}>Print</button>
            <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.6)",fontSize:22,cursor:"pointer"}}>X</button>
          </div>
        </div>
        {/* Certificate body with automotive background */}
        <div style={{position:"relative",padding:"48px 56px",fontFamily:"Georgia,serif",overflow:"hidden"}}>
          {/* Background SVG -engine/gear/molecule pattern */}
          <svg style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",opacity:0.045,pointerEvents:"none"}} viewBox="0 0 700 900" preserveAspectRatio="xMidYMid slice">
            {/* Large gear top-left */}
            <g transform="translate(60,80)">
              <circle cx="0" cy="0" r="72" fill="none" stroke="#0B1F3A" strokeWidth="8"/>
              <circle cx="0" cy="0" r="24" fill="none" stroke="#0B1F3A" strokeWidth="6"/>
              {[0,30,60,90,120,150,180,210,240,270,300,330].map(a=>(
                <rect key={a} x="-7" y="-88" width="14" height="22" rx="3" fill="#0B1F3A" transform={`rotate(${a})`}/>
              ))}
            </g>
            {/* Large gear bottom-right */}
            <g transform="translate(640,820)">
              <circle cx="0" cy="0" r="88" fill="none" stroke="#0B1F3A" strokeWidth="10"/>
              <circle cx="0" cy="0" r="28" fill="none" stroke="#0B1F3A" strokeWidth="6"/>
              {[0,30,60,90,120,150,180,210,240,270,300,330].map(a=>(
                <rect key={a} x="-8" y="-105" width="16" height="24" rx="3" fill="#0B1F3A" transform={`rotate(${a})`}/>
              ))}
            </g>
            {/* Small gear top-right */}
            <g transform="translate(620,100)">
              <circle cx="0" cy="0" r="44" fill="none" stroke="#0B1F3A" strokeWidth="6"/>
              <circle cx="0" cy="0" r="14" fill="none" stroke="#0B1F3A" strokeWidth="4"/>
              {[0,45,90,135,180,225,270,315].map(a=>(
                <rect key={a} x="-5" y="-54" width="10" height="16" rx="2" fill="#0B1F3A" transform={`rotate(${a})`}/>
              ))}
            </g>
            {/* Piston left */}
            <g transform="translate(30,400)">
              <rect x="-18" y="-60" width="36" height="120" rx="6" fill="#0B1F3A"/>
              <rect x="-22" y="-72" width="44" height="24" rx="4" fill="#0B1F3A"/>
              <rect x="-22" y="48" width="44" height="24" rx="4" fill="#0B1F3A"/>
              <rect x="-4" y="72" width="8" height="80" rx="4" fill="#0B1F3A"/>
            </g>
            {/* Piston right */}
            <g transform="translate(670,450)">
              <rect x="-18" y="-60" width="36" height="120" rx="6" fill="#0B1F3A"/>
              <rect x="-22" y="-72" width="44" height="24" rx="4" fill="#0B1F3A"/>
              <rect x="-22" y="48" width="44" height="24" rx="4" fill="#0B1F3A"/>
              <rect x="-4" y="72" width="8" height="80" rx="4" fill="#0B1F3A"/>
            </g>
            {/* Molecule / chemical dots -represent nanotechnology */}
            {[[200,160],[480,200],[150,700],[520,680],[350,860]].map(([x,y],i)=>(
              <g key={i} transform={`translate(${x},${y})`}>
                <circle cx="0" cy="0" r="12" fill="#0B1F3A"/>
                <circle cx="38" cy="-22" r="8" fill="#0B1F3A"/>
                <circle cx="-38" cy="-22" r="8" fill="#0B1F3A"/>
                <circle cx="38" cy="22" r="8" fill="#0B1F3A"/>
                <line x1="0" y1="0" x2="38" y2="-22" stroke="#0B1F3A" strokeWidth="3"/>
                <line x1="0" y1="0" x2="-38" y2="-22" stroke="#0B1F3A" strokeWidth="3"/>
                <line x1="0" y1="0" x2="38" y2="22" stroke="#0B1F3A" strokeWidth="3"/>
              </g>
            ))}
            {/* Exhaust/emission lines -wavy */}
            <path d="M320 30 Q340 50 320 70 Q300 90 320 110 Q340 130 320 150" fill="none" stroke="#0B1F3A" strokeWidth="3"/>
            <path d="M350 30 Q370 50 350 70 Q330 90 350 110 Q370 130 350 150" fill="none" stroke="#0B1F3A" strokeWidth="3"/>
            <path d="M380 30 Q400 50 380 70 Q360 90 380 110 Q400 130 380 150" fill="none" stroke="#0B1F3A" strokeWidth="3"/>
            {/* Wrench bottom-left */}
            <g transform="translate(80,780) rotate(-35)">
              <rect x="-6" y="-70" width="12" height="120" rx="4" fill="#0B1F3A"/>
              <circle cx="0" cy="-70" r="20" fill="none" stroke="#0B1F3A" strokeWidth="7"/>
              <circle cx="0" cy="-70" r="8" fill="#0B1F3A"/>
              <rect x="-20" y="48" width="40" height="16" rx="8" fill="#0B1F3A"/>
            </g>
            {/* TUV badge outline top-center */}
            <rect x="290" y="840" width="120" height="44" rx="8" fill="none" stroke="#0B1F3A" strokeWidth="4"/>
            <text x="350" y="868" textAnchor="middle" fontSize="18" fontWeight="700" fill="#0B1F3A" fontFamily="Arial">T-V</text>
          </svg>

          {/* Gold border frame */}
          <div style={{position:"absolute",top:12,left:12,right:12,bottom:12,border:"2px solid #B8972A",borderRadius:8,pointerEvents:"none"}}/>
          <div style={{position:"absolute",top:18,left:18,right:18,bottom:18,border:"1px solid #D4AF37",borderRadius:6,pointerEvents:"none",opacity:0.5}}/>

          {/* Content */}
          <div style={{position:"relative",textAlign:"center",marginBottom:32}}>
            <img src="/mpc-logo.png" alt="MotorPower Care" style={{width:120,height:"auto",marginBottom:10,objectFit:"contain"}}/>
            <div style={{fontSize:11,letterSpacing:"0.1em",textTransform:"uppercase",color:C.inkLight,marginBottom:24}}>Authorized Distributor Certification Program</div>
            <div style={{height:2,background:`linear-gradient(to right, transparent, #B8972A, transparent)`,marginBottom:24}}/>
            <div style={{fontSize:12,letterSpacing:"0.12em",textTransform:"uppercase",color:C.inkLight,marginBottom:14}}>This certifies that</div>
            <div style={{fontSize:32,fontWeight:700,color:C.navy,fontFamily:"Georgia,serif",marginBottom:6,borderBottom:`2px solid #B8972A`,paddingBottom:8,display:"inline-block",minWidth:300}}>{cert.name}</div>
            <div style={{fontSize:13,color:C.inkMid,marginTop:8,marginBottom:18}}>of <strong>{cert.shopName}</strong></div>
            <div style={{fontSize:12,letterSpacing:"0.08em",textTransform:"uppercase",color:C.inkLight,marginBottom:8}}>has successfully completed the</div>
            <div style={{fontSize:20,fontWeight:600,color:C.navy,marginBottom:4,fontFamily:"Georgia,serif"}}>
              {cert.track==="tech" ? "MotorPower Care Technician Certification" : "MotorPower Care Service Advisor Certification"}
            </div>
            <div style={{fontSize:13,color:C.inkMid,marginBottom:24}}>
              {cert.track==="tech" ? "Product Application & Diagnostic Mastery" : "Sales Excellence & Service Benefit Mastery"}
            </div>
            <div style={{height:1,background:`linear-gradient(to right, transparent, ${C.border}, transparent)`,marginBottom:24}}/>
          </div>

          <div style={{position:"relative",display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:16,marginBottom:24,textAlign:"center"}}>
            {[["Certificate number",cert.certNum,C.navy],["Issue date",cert.date,C.navy],["Final score",`${cert.score}%`,C.teal]].map(([l,v,col])=>(
              <div key={l} style={{padding:"12px",border:`1px solid #D4AF37`,borderRadius:8,background:"rgba(212,175,55,0.04)"}}>
                <div style={{fontSize:10,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:4}}>{l}</div>
                <div style={{fontSize:13,fontWeight:600,color:col}}>{v}</div>
              </div>
            ))}
          </div>

          <div style={{position:"relative",marginBottom:24,padding:"14px 16px",background:C.surface,borderRadius:8,border:`1px solid ${C.border}`}}>
            <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:C.inkLight,marginBottom:8}}>Courses completed</div>
            {(cert.completedVideos||[]).map((v,i)=>(
              <div key={i} style={{fontSize:12,color:C.inkMid,padding:"4px 0",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between"}}>
                <span>{v.title}</span><span style={{color:C.teal,fontWeight:500}}>{v.score}%</span>
              </div>
            ))}
          </div>

          <div style={{position:"relative",display:"grid",gridTemplateColumns:"1fr 1fr",gap:24,marginTop:28}}>
            <div style={{textAlign:"center"}}>
              <div style={{borderBottom:`1px solid ${C.ink}`,paddingBottom:4,marginBottom:6,fontFamily:"cursive",fontSize:18,color:C.navy,minHeight:32}}>{cert.signature}</div>
              <div style={{fontSize:11,color:C.inkLight}}>Certified individual signature</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{borderBottom:`1px solid ${C.ink}`,paddingBottom:4,marginBottom:6,minHeight:32,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
                <div style={{fontFamily:"'Brush Script MT',cursive",fontSize:22,color:C.navy,fontStyle:"italic"}}>MotorPower Care</div>
              </div>
              <div style={{fontSize:11,color:C.inkLight}}>Authorized by MotorPower Care Inc.</div>
            </div>
          </div>

          <div style={{position:"relative",marginTop:28,textAlign:"center",fontSize:10,color:C.inkLight,lineHeight:1.8}}>
            This certificate verifies completion of the MotorPower Care authorized training program.<br/>
            Certificate #{cert.certNum} . Issued by MotorPower Care . info@mpcare.com . www.mpcare.com<br/>
            To verify this certificate, contact info@mpcare.com with the certificate number.
          </div>
        </div>
      </div>
    </div>
  );
}

// """ QUIZ ENGINE """"""""""""""""""""""""""""""""""""""""""""""""""""""""""""""
function QuizEngine({video, techName, onComplete, onExit}) {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [signature, setSignature] = useState("");

  const questions = video.questions || [];
  const q = questions[current];

  const score = submitted ? Math.round(
    (Object.entries(answers).filter(([qi,ai])=>questions[parseInt(qi)].answer===ai).length / questions.length) * 100
  ) : 0;

  const passed = score >= 70;

  if(submitted) return (
    <div style={{maxWidth:520,margin:"0 auto",padding:24}}>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{width:72,height:72,borderRadius:"50%",background:passed?C.greenLight:C.redLight,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px",fontSize:32}}>
          {passed?"YES":"X"}
        </div>
        <div style={{fontSize:22,fontWeight:600,color:passed?C.green:C.red,marginBottom:4}}>
          {passed?"Quiz passed!":"Quiz not passed"}
        </div>
        <div style={{fontSize:14,color:C.inkLight,marginBottom:4}}>Score: <strong style={{color:passed?C.green:C.red}}>{score}%</strong></div>
        <div style={{fontSize:13,color:C.inkLight}}>{passed?"70% minimum required — you passed!":"70% minimum required. You can retake the quiz."}</div>
      </div>

      {passed && !signature && (
        <div style={{...S.card,padding:20}}>
          <div style={{fontSize:14,fontWeight:600,color:C.ink,marginBottom:4}}>Almost there — sign below</div>
          <div style={{fontSize:12,color:C.inkLight,marginBottom:16}}>By signing, {techName} certifies they completed this course and will apply this knowledge in their role.</div>
          <div style={S.fg}><label style={S.label}>Full legal name (typed as signature)</label>
            <input style={{...S.input,fontFamily:"cursive",fontSize:16}} value={signature} onChange={e=>setSignature(e.target.value)} placeholder="Type full name as signature"/>
          </div>
          <button style={{...S.btnPrimary,width:"100%",opacity:signature.trim()?1:0.5,cursor:signature.trim()?"pointer":"not-allowed"}} disabled={!signature.trim()} onClick={()=>onComplete({video,score,signature:signature.trim(),passed:true})}>
            Sign & receive certificate
          </button>
        </div>
      )}

      {!passed && (
        <div style={{display:"flex",gap:10,justifyContent:"center"}}>
          <button style={S.btnSecondary} onClick={onExit}>Back to training</button>
          <button style={S.btnPrimary} onClick={()=>{setAnswers({});setSubmitted(false);setCurrent(0);}}>Retake quiz</button>
        </div>
      )}

      <div style={{marginTop:20}}>
        <div style={{fontSize:13,fontWeight:500,color:C.ink,marginBottom:10}}>Review your answers</div>
        {questions.map((q,i)=>{
          const userAns = answers[i];
          const correct = userAns===q.answer;
          return (
            <div key={i} style={{marginBottom:12,padding:"10px 14px",background:correct?C.greenLight:C.redLight,borderRadius:8}}>
              <div style={{fontSize:12,fontWeight:600,color:correct?C.green:C.red,marginBottom:4}}>{i+1}. {q.q}</div>
              <div style={{fontSize:12,color:correct?C.green:C.red}}>
                Your answer: {q.opts[userAns]||"Not answered"}{!correct&&<span> . Correct: {q.opts[q.answer]}</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div style={{maxWidth:520,margin:"0 auto",padding:24}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div style={{fontSize:13,color:C.inkLight}}>{video.title}</div>
        <span style={{fontSize:12,color:C.inkLight}}>Question {current+1} of {questions.length}</span>
      </div>
      <div style={{height:4,background:C.border,borderRadius:2,marginBottom:24,overflow:"hidden"}}>
        <div style={{height:"100%",background:C.blue,width:`${(current/questions.length)*100}%`,transition:"width 0.3s",borderRadius:2}}/>
      </div>
      <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:20,lineHeight:1.5}}>{q.q}</div>
      <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:24}}>
        {q.opts.map((opt,i)=>(
          <div key={i} onClick={()=>setAnswers(a=>({...a,[current]:i}))}
            style={{padding:"12px 16px",borderRadius:10,border:`2px solid ${answers[current]===i?C.blue:C.border}`,background:answers[current]===i?C.blueLight:C.white,cursor:"pointer",fontSize:13,color:answers[current]===i?C.blue:C.ink,fontWeight:answers[current]===i?500:400}}>
            {opt}
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:10}}>
        {current>0&&<button style={S.btnSecondary} onClick={()=>setCurrent(c=>c-1)}>← Back</button>}
        {/* Next/Submit are deliberately disabled until the current question
            is answered — but S.btnPrimary has no built-in disabled styling,
            so the button looked fully clickable (same blue, no dimming)
            while silently blocking the click. That's what read as "the
            button doesn't work" — it worked, there was just zero visual
            cue for why nothing happened. Explicit opacity/cursor here
            matches the disabled-state convention already used elsewhere
            in this app (e.g. Watch buttons with no videoUrl). */}
        {current<questions.length-1
          ? <button style={{...S.btnPrimary,flex:1,opacity:answers[current]===undefined?0.5:1,cursor:answers[current]===undefined?"not-allowed":"pointer"}} disabled={answers[current]===undefined} onClick={()=>setCurrent(c=>c+1)}>Next →</button>
          : <button style={{...S.btnPrimary,flex:1,opacity:answers[current]===undefined?0.5:1,cursor:answers[current]===undefined?"not-allowed":"pointer"}} disabled={answers[current]===undefined} onClick={()=>setSubmitted(true)}>Submit quiz</button>
        }
      </div>
    </div>
  );
}

// """ CERTIFICATION FLOW (shop side) """"""""""""""""""""""""""""""""""""""""""
function CertificationFlow({techName, track, onComplete, onExit}) {
  const [step, setStep] = useState("intro"); // intro | watch | quiz | done
  const [currentVideoIdx, setCurrentVideoIdx] = useState(0);
  const [completedVideos, setCompletedVideos] = useState([]);
  // Real video embed for the "watch" step below — this used to be a static
  // navy box with the literal text "PLAY" and no video ever actually
  // played, regardless of whether admin had set a videoUrl on the cert
  // video (AdminCertificationTab's Add/Edit video modal has always had a
  // Video URL field). Same embed pattern as the Training hub preview
  // (App.js CustomerTraining / RepPortal TrainingHub / AdminTrainingTab).
  const getEmbedUrl = (url, type) => {
    if (!url) return "";
    if ((type||"youtube") === "youtube") { const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?/]+)/); return m ? `https://www.youtube.com/embed/${m[1]}` : url; }
    if (type === "vimeo") { const m = url.match(/vimeo\.com\/(\d+)/); return m ? `https://player.vimeo.com/video/${m[1]}` : url; }
    return url;
  };

  const trackVideos = INIT_CERT_VIDEOS.filter(v=>v.track===track&&v.required&&v.active);
  const currentVideo = trackVideos[currentVideoIdx];
  const allDone = completedVideos.length>=trackVideos.length;

  const handleQuizComplete = ({video,score,signature,passed}) => {
    if(!passed) return;
    const completed = [...completedVideos,{videoId:video.id,title:video.title,score}];
    setCompletedVideos(completed);
    if(completed.length>=trackVideos.length) {
      const certNum = genCertNum(track);
      const avgScore = Math.round(completed.reduce((s,v)=>s+v.score,0)/completed.length);
      onComplete({certNum,signature,score:avgScore,completedVideos:completed});
    } else {
      setCurrentVideoIdx(i=>i+1);
      setStep("watch");
    }
  };

  if(step==="intro") return (
    <div style={{maxWidth:560,margin:"0 auto",padding:24}}>
      <div style={{textAlign:"center",marginBottom:28}}>
        <div style={{width:64,height:64,borderRadius:"50%",background:track==="tech"?C.tealLight:C.blueLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,margin:"0 auto 16px"}}>
          {track==="tech"?"T":"S"}
        </div>
        <div style={{fontSize:22,fontWeight:600,color:C.ink,marginBottom:6}}>
          {track==="tech"?"Technician Certification":"Service Advisor Certification"}
        </div>
        <div style={{fontSize:13,color:C.inkLight,marginBottom:20}}>Starting certification for: <strong style={{color:C.ink}}>{techName}</strong></div>
      </div>
      <div style={{...S.card,padding:20,marginBottom:16}}>
        <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:10}}>What to expect</div>
        {[
          [`${trackVideos.length} required videos`,`Watch each video fully — you can pause and re-watch`],
          ["Quiz after each video","5 multiple choice questions — minimum 70% to pass"],
          ["Retakes allowed","Failed quizzes can be retaken immediately"],
          ["Certificate issued","Unique certificate number generated on completion"],
        ].map(([t,d])=>(
          <div key={t} style={{display:"flex",gap:10,marginBottom:8}}>
            <div style={{width:20,height:20,borderRadius:"50%",background:C.tealLight,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:C.teal}}>OK</div>
            <div><div style={{fontSize:12,fontWeight:500,color:C.ink}}>{t}</div><div style={{fontSize:11,color:C.inkLight}}>{d}</div></div>
          </div>
        ))}
      </div>
      <div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.amber,marginBottom:20}}>
        Please ensure the technician is present and ready to watch the videos. Do not start on their behalf.
      </div>
      <div style={{display:"flex",gap:10}}>
        <button style={S.btnSecondary} onClick={onExit}>Cancel</button>
        <button style={{...S.btnPrimary,flex:1}} onClick={()=>setStep("watch")}>Begin certification →</button>
      </div>
    </div>
  );

  if(step==="watch") return (
    <div style={{maxWidth:560,margin:"0 auto",padding:24}}>
      <div style={{marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
          <span style={{fontSize:13,fontWeight:500,color:C.ink}}>Video {currentVideoIdx+1} of {trackVideos.length}</span>
          <span style={{fontSize:12,color:C.inkLight}}>{completedVideos.length} completed</span>
        </div>
        <div style={{height:6,background:C.border,borderRadius:3,overflow:"hidden"}}>
          <div style={{height:"100%",background:C.teal,width:`${(completedVideos.length/trackVideos.length)*100}%`,borderRadius:3}}/>
        </div>
      </div>
      <div style={{...S.card,overflow:"hidden",marginBottom:16}}>
        {currentVideo?.videoUrl ? (
          <div style={{position:"relative",paddingBottom:"56.25%",background:"#000"}}>
            {(currentVideo.videoType==="direct"||currentVideo.videoType==="file")
              ? <video src={currentVideo.videoUrl} controls style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}}/>
              : <iframe title={currentVideo.title||"certification video"} src={getEmbedUrl(currentVideo.videoUrl,currentVideo.videoType)} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>}
          </div>
        ) : (
          <div style={{background:C.navy,height:200,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:12}}>
            <div style={{width:56,height:56,borderRadius:"50%",background:"rgba(255,255,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"rgba(255,255,255,0.7)",textAlign:"center"}}>No video URL</div>
            <div style={{fontSize:13,color:C.white,fontWeight:500}}>{currentVideo?.title}</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.6)"}}>{currentVideo?.duration}</div>
          </div>
        )}
        <div style={{padding:"14px 18px"}}>
          <div style={{fontSize:12,color:C.inkMid,lineHeight:1.6}}>{currentVideo?.desc}</div>
        </div>
      </div>
      <div style={{background:C.blueLight,borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1D4ED8",marginBottom:16}}>
        Watch the full video, then proceed to the quiz. The "Take quiz" button activates after watching.
      </div>
      <div style={{display:"flex",gap:10}}>
        <button style={S.btnSecondary} onClick={onExit}>Save & exit</button>
        <button style={{...S.btnPrimary,flex:1}} onClick={()=>setStep("quiz")}>I've watched this — take quiz</button>
      </div>
    </div>
  );

  if(step==="quiz") return (
    <QuizEngine video={currentVideo} techName={techName} onComplete={handleQuizComplete} onExit={()=>setStep("watch")}/>
  );

  return null;
}

// """ SHOP CERTIFICATION PAGE """"""""""""""""""""""""""""""""""""""""""""""""""
export function ShopCertification({ session, profile, onSignOut }) {
  // Start every dealer with a clean roster. INIT_TECHNICIANS (Carlos M.,
  // Tony R., Sarah K., Mike D. at @apexcarcare.com) was historically used
  // as the seed for this state, which caused EVERY real dealer to see those
  // 4 fake names under "My team & certification" until they manually added
  // their own technicians. Per the rule on no rewriting of customer data:
  // there is no localStorage / Supabase persistence for technicians, so
  // existing dealers had no real data here to lose — only the misleading
  // demo seed disappears. The INIT_TECHNICIANS constant + its export are
  // intentionally preserved as reference / test fixtures; nothing else in
  // src/ imports them.
  const [technicians, setTechnicians] = useState([]);
  const [certifying, setCertifying] = useState(null); // {techId, track}
  const [addingTech, setAddingTech] = useState(false);
  const [newTech, setNewTech] = useState({name:"",role:"tech",email:""});
  const [viewCert, setViewCert] = useState(null);
  const [tab, setTab] = useState("all");

  const filtered = tab==="all" ? technicians :
    tab==="tech" ? technicians.filter(t=>t.role==="tech") :
    technicians.filter(t=>t.role==="advisor");

  const certified = technicians.filter(t=>t.status==="certified").length;

  const handleCertComplete = (techId, track, result) => {
    const today = new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"});
    setTechnicians(ts=>ts.map(t=>t.id===techId?{
      ...t,
      status:"certified",
      certNum:result.certNum,
      certDate:today,
      score:result.score,
      track,
      signature:result.signature,
      completedVideos:result.completedVideos,
    }:t));
    setCertifying(null);
  };

  const addTechnician = () => {
    if(!newTech.name.trim()) return;
    setTechnicians(ts=>[...ts,{id:Date.now(),shopId:1,...newTech,status:"not_certified",certNum:"",certDate:"",score:0}]);
    setAddingTech(false);
    setNewTech({name:"",role:"tech",email:""});
  };

  if(certifying) {
    const tech = technicians.find(t=>t.id===certifying.techId);
    return (
      <div style={{...S.app,padding:0}}>
        <div style={{background:C.navy,padding:"12px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{color:C.white,fontSize:13,fontWeight:500}}>MPC Certification -{tech?.name}</span>
          <button onClick={()=>setCertifying(null)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:C.white,fontSize:12,padding:"5px 12px",borderRadius:6,cursor:"pointer"}}>Save & exit</button>
        </div>
        <CertificationFlow
          techName={tech?.name}
          track={certifying.track}
          onComplete={(result)=>handleCertComplete(certifying.techId,certifying.track,result)}
          onExit={()=>setCertifying(null)}
        />
      </div>
    );
  }

  return (
    <div style={S.content}>
      {viewCert && <CertificateDoc cert={viewCert} onClose={()=>setViewCert(null)}/>}

      {addingTech && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
          <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:440}}>
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:16}}>Add team member</div>
            <div style={S.fg}><label style={S.label}>Full name *</label><input style={S.input} value={newTech.name} onChange={e=>setNewTech(v=>({...v,name:e.target.value}))} placeholder="Carlos Martinez"/></div>
            <div style={S.fg}><label style={S.label}>Role</label>
              <select style={S.select} value={newTech.role} onChange={e=>setNewTech(v=>({...v,role:e.target.value}))}>
                <option value="tech">Technician</option>
                <option value="advisor">Service advisor</option>
              </select>
            </div>
            <div style={S.fg}><label style={S.label}>Email (optional)</label><input style={S.input} value={newTech.email} onChange={e=>setNewTech(v=>({...v,email:e.target.value}))} placeholder="carlos@shop.com"/></div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={()=>setAddingTech(false)}>Cancel</button>
              <button style={S.btnPrimary} onClick={addTechnician}>Add team member</button>
            </div>
          </div>
        </div>
      )}

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div>
          <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Team certification</div>
          <div style={{fontSize:13,color:C.inkLight}}>{certified} of {technicians.length} team members certified . Certified members carry more value to your customers</div>
        </div>
        <button style={S.btnPrimary} onClick={()=>setAddingTech(true)}>+ Add team member</button>
      </div>

      {/* Stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
        {[
          {l:"Total team",v:technicians.length},
          {l:"Certified",v:technicians.filter(t=>t.status==="certified").length,up:true},
          {l:"Technicians",v:technicians.filter(t=>t.role==="tech").length},
          {l:"Service advisors",v:technicians.filter(t=>t.role==="advisor").length},
        ].map(m=>(
          <div key={m.l} style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 16px"}}>
            <div style={{fontSize:11,color:C.inkLight,marginBottom:3}}>{m.l}</div>
            <div style={{fontSize:20,fontWeight:600,color:m.up?C.teal:C.ink}}>{m.v}</div>
          </div>
        ))}
      </div>

      {/* Uncertified warning banner with remind all */}
      {technicians.filter(t=>t.status==="not_certified").length>0 && (
        <div style={{background:"#FEF08A",border:`1px solid #EAB308`,borderRadius:10,padding:"12px 16px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:"#92400E",marginBottom:2}}>
              {technicians.filter(t=>t.status==="not_certified").length} team member{technicians.filter(t=>t.status==="not_certified").length>1?"s":""} not yet certified
            </div>
            <div style={{fontSize:12,color:"#92400E"}}>Certified technicians and advisors drive higher product sales and customer trust.</div>
          </div>
          <button style={{...S.btnPrimary,background:"#92400E",flexShrink:0}} onClick={()=>{
            const uncert=technicians.filter(t=>t.status==="not_certified"&&t.email);
            setTechnicians(ts=>ts.map(t=>t.status==="not_certified"&&t.email?{...t,lastReminder:new Date().toLocaleDateString("en-US",{month:"short",day:"numeric"})}:t));
            alert(`Reminder sent to ${uncert.length} team member${uncert.length>1?"s":""}`);
          }}>Send reminder to all</button>
        </div>
      )}

      {/* Filter tabs */}
      <div style={{display:"flex",gap:6,marginBottom:14}}>
        {[["all","All"],["tech","Technicians"],["advisor","Service advisors"]].map(([k,l])=>(
          <button key={k} onClick={()=>setTab(k)} style={{padding:"5px 14px",borderRadius:7,border:`1px solid ${tab===k?C.blue:C.border}`,background:tab===k?C.blueLight:C.white,color:tab===k?C.blue:C.inkMid,fontSize:12,cursor:"pointer"}}>
            {l}
          </button>
        ))}
      </div>

      {/* Team roster */}
      <div style={S.card}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 90px 90px 80px 120px 100px 80px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span>Name</span><span>Role</span><span>Track</span><span>Score</span><span>Certificate</span><span>Status</span><span></span>
        </div>
        {filtered.length === 0 && (
          <div style={{padding:"32px 18px",textAlign:"center",color:C.inkLight,fontSize:13}}>
            {technicians.length === 0
              ? <>No team members added yet. Click <strong style={{color:C.ink}}>+ Add team member</strong> above to start.</>
              : <>No team members match this filter.</>
            }
          </div>
        )}
        {filtered.map(tech=>(
          <div key={tech.id} style={{display:"grid",gridTemplateColumns:"1fr 90px 90px 80px 120px 100px 80px",alignItems:"center",gap:8,padding:"13px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,background:tech.status==="not_certified"?"#FFFEF0":"transparent"}}>
            <div>
              <div style={{fontWeight:500,color:C.ink}}>{tech.name}</div>
              {tech.email&&<div style={{fontSize:11,color:C.inkLight}}>{tech.email}</div>}
              {tech.lastReminder&&<div style={{fontSize:10,color:C.amber}}>Last reminder: {tech.lastReminder}</div>}
            </div>
            <span style={{fontSize:11,color:C.inkLight,textTransform:"capitalize"}}>{tech.role==="tech"?"Technician":"Svc advisor"}</span>
            <span style={{fontSize:11,color:C.inkLight,textTransform:"capitalize"}}>{tech.track||" -"}</span>
            <span style={{fontWeight:500,color:tech.score>0?C.teal:C.inkLight}}>{tech.score>0?`${tech.score}%`:" -"}</span>
            <div>
              {tech.certNum ? (
                <div style={{fontSize:11,color:C.blue,cursor:"pointer",fontWeight:500}} onClick={()=>setViewCert({...tech,shopName:profile?.company||session?.user?.user_metadata?.company||"Your shop",date:tech.certDate,completedVideos:tech.completedVideos||[]})}>
                  {tech.certNum}
                </div>
              ) : <span style={{color:C.inkLight}}> -</span>}
            </div>
            <div>
              {tech.status==="certified"
                ? <span style={S.pillGreen}>Certified</span>
                : <span style={{fontSize:10,fontWeight:600,padding:"3px 10px",borderRadius:8,background:"#FEF08A",color:"#92400E",display:"flex",alignItems:"center",gap:4,width:"fit-content"}}>Not certified</span>
              }
            </div>
            <div style={{display:"flex",gap:4}}>
              {tech.status==="not_certified" && (
                <div style={{display:"flex",flexDirection:"column",gap:4}}>
                  <button style={S.btnSmall} onClick={()=>setCertifying({techId:tech.id,track:"tech"})}>Tech cert</button>
                  <button style={{...S.btnSmall,background:C.blueLight,color:C.blue}} onClick={()=>setCertifying({techId:tech.id,track:"advisor"})}>SA cert</button>
                  {tech.email&&<button style={{...S.btnSmall,background:C.amberLight,color:C.amber,fontSize:10}} onClick={()=>{setTechnicians(ts=>ts.map(t=>t.id===tech.id?{...t,lastReminder:new Date().toLocaleDateString("en-US",{month:"short",day:"numeric"})}:t));alert(`Reminder sent to ${tech.email}`);}}>Remind</button>}
                </div>
              )}
              {tech.status==="certified" && (
                <button style={S.btnSuccess} onClick={()=>setViewCert({...tech,shopName:profile?.company||session?.user?.user_metadata?.company||"Your shop",date:tech.certDate,completedVideos:tech.completedVideos||[]})}>View cert</button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Refresh training note */}
      <div style={{background:C.blueLight,borderRadius:10,padding:"12px 16px",marginTop:4}}>
        <div style={{fontSize:12,fontWeight:500,color:"#1D4ED8",marginBottom:2}}>Refresher training available</div>
        <div style={{fontSize:12,color:"#1E40AF"}}>Certified team members can re-watch any training video at any time to refresh their knowledge. Go to Training & demos in the sidebar.</div>
      </div>
    </div>
  );
}

// -ADMIN CERTIFICATION MANAGEMENT ------------------------------------------
export function AdminCertificationTab() {
  const [videos, setVideos] = useState(INIT_CERT_VIDEOS);
  const [tab, setTab] = useState("videos");
  const [addingVideo, setAddingVideo] = useState(false);
  const [editVideoId, setEditVideoId] = useState(null);
  const [videoForm, setVideoForm] = useState({title:"",track:"tech",duration:"",required:true,active:true,desc:"",videoUrl:"",questions:[]});
  const [editingQ, setEditingQ] = useState(null);
  const [tempQuestions, setTempQuestions] = useState([]);
  const [viewCert, setViewCert] = useState(null);

  // Live cert registry -tracks all issued certs across all shops
  const [certs, setCerts] = useState([
    {certNum:"MPC-TECH-2025-00001",name:"Carlos M.",shop:"Apex Car Care LLC",track:"tech",score:100,date:"Mar 20, 2025",status:"issued",category:"Product Application & Diagnostic Mastery",completedVideos:[{title:"Catalytic converter cleaner",score:100},{title:"DPF product line",score:100}],signature:"Carlos Martinez"},
    {certNum:"MPC-SA-2025-00001",name:"Sarah K.",shop:"Apex Car Care LLC",track:"advisor",score:80,date:"Apr 1, 2025",status:"issued",category:"Sales Excellence & Service Benefit Mastery",completedVideos:[{title:"How to sell maintenance products",score:85},{title:"Service benefit key points",score:75}],signature:"Sarah Kim"},
    {certNum:"MPC-TECH-2025-00002",name:"James L.",shop:"FastLane Auto Parts",track:"tech",score:90,date:"Apr 8, 2025",status:"pending_mail",category:"Product Application & Diagnostic Mastery",completedVideos:[{title:"Catalytic converter cleaner",score:95},{title:"DPF product line",score:85}],signature:"James Lee"},
  ]);

  // Notification log
  const [notifications, setNotifications] = useState([
    {id:1,type:"cert_completed",text:"Carlos M. (Apex Car Care LLC) completed Technician Certification -score 100%",date:"Mar 20, 2025",read:true},
    {id:2,type:"cert_completed",text:"Sarah K. (Apex Car Care LLC) completed Service Advisor Certification -score 80%",date:"Apr 1, 2025",read:true},
    {id:3,type:"cert_completed",text:"James L. (FastLane Auto Parts) completed Technician Certification -score 90%",date:"Apr 8, 2025",read:false},
  ]);

  const [settings, setSettings] = useState({passScore:70,questionsPerVideo:5,retakes:"Unlimited",validity:"No expiry",notifyEmail:"info@mpcare.com"});

  const startEditQuestions = (video) => { setEditingQ(video); setTempQuestions(JSON.parse(JSON.stringify(video.questions))); };
  const saveQuestions = () => { setVideos(vs=>vs.map(v=>v.id===editingQ.id?{...v,questions:tempQuestions}:v)); setEditingQ(null); };
  const addQuestion = () => setTempQuestions(qs=>[...qs,{id:Date.now(),q:"",opts:["","","",""],answer:0}]);
  const updateQ = (i,field,val) => setTempQuestions(qs=>qs.map((q,qi)=>qi===i?{...q,[field]:val}:q));
  const updateOpt = (qi,oi,val) => setTempQuestions(qs=>qs.map((q,i)=>i===qi?{...q,opts:q.opts.map((o,j)=>j===oi?val:o)}:q));

  const openAddVideo = () => { setEditVideoId(null); setVideoForm({title:"",track:"tech",duration:"",required:true,active:true,desc:"",videoUrl:"",questions:[]}); setAddingVideo(true); };
  const openEditVideo = (v) => { setEditVideoId(v.id); setVideoForm({title:v.title,track:v.track,duration:v.duration,required:v.required,active:v.active,desc:v.desc,videoUrl:v.videoUrl||"",questions:v.questions}); setAddingVideo(true); };
  const saveVideo = () => {
    if(!videoForm.title) return;
    if(editVideoId) { setVideos(vs=>vs.map(v=>v.id===editVideoId?{...v,...videoForm}:v)); }
    else { setVideos(vs=>[...vs,{id:Date.now(),...videoForm}]); }
    setAddingVideo(false); setEditVideoId(null);
  };

  const markShipped = (certNum) => {
    setCerts(cs=>cs.map(c=>c.certNum===certNum?{...c,status:"shipped"}:c));
    const cert=certs.find(c=>c.certNum===certNum);
    if(cert) setNotifications(ns=>[{id:Date.now(),type:"cert_shipped",text:`Certificate ${certNum} shipped to ${cert.name} (${cert.shop})`,date:new Date().toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}),read:false},...ns]);
  };
  const markIssued = (certNum) => setCerts(cs=>cs.map(c=>c.certNum===certNum?{...c,status:"issued"}:c));

  const unread = notifications.filter(n=>!n.read).length;

  return (
    <div>
      {/* Add/Edit video modal */}
      {addingVideo && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}}>
          <div style={{background:C.white,borderRadius:16,padding:"24px",width:580,maxHeight:"85vh",overflowY:"auto"}}>
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:16}}>{editVideoId?"Edit certification video":"Add certification video"}</div>
            <div style={S.fg}><label style={S.label}>Video title *</label><input style={S.input} value={videoForm.title} onChange={e=>setVideoForm(v=>({...v,title:e.target.value}))} placeholder="DPF product line -complete system"/></div>
            <div style={S.fg}><label style={S.label}>Video URL (YouTube, Vimeo, or direct link)</label><input style={S.input} value={videoForm.videoUrl} onChange={e=>setVideoForm(v=>({...v,videoUrl:e.target.value}))} placeholder="https://www.youtube.com/watch?v=..."/></div>
            <div style={S.twoCol}>
              <div style={S.fg}><label style={S.label}>Track</label>
                <select style={S.select} value={videoForm.track} onChange={e=>setVideoForm(v=>({...v,track:e.target.value}))}>
                  <option value="tech">Technician (How to use)</option>
                  <option value="advisor">Service Advisor (How to sell)</option>
                </select>
              </div>
              <div style={S.fg}><label style={S.label}>Duration</label><input style={S.input} value={videoForm.duration} onChange={e=>setVideoForm(v=>({...v,duration:e.target.value}))} placeholder="8 min"/></div>
            </div>
            <div style={S.fg}><label style={S.label}>Description</label><textarea style={{...S.input,height:64,resize:"vertical"}} value={videoForm.desc} onChange={e=>setVideoForm(v=>({...v,desc:e.target.value}))}/></div>
            <div style={{display:"flex",gap:16,marginBottom:14}}>
              <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.ink,cursor:"pointer"}}><input type="checkbox" checked={videoForm.required} onChange={e=>setVideoForm(v=>({...v,required:e.target.checked}))}/>Required for certification</label>
              <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.ink,cursor:"pointer"}}><input type="checkbox" checked={videoForm.active} onChange={e=>setVideoForm(v=>({...v,active:e.target.checked}))}/>Active</label>
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={()=>{setAddingVideo(false);setEditVideoId(null);}}>Cancel</button>
              <button style={S.btnPrimary} onClick={saveVideo}>{editVideoId?"Save changes":"Add video"}</button>
            </div>
          </div>
        </div>
      )}

      {/* Question editor modal */}
      {editingQ && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}}>
          <div style={{background:C.white,borderRadius:16,padding:"24px",width:640,maxHeight:"85vh",overflowY:"auto"}}>
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:4}}>Edit quiz questions</div>
            <div style={{fontSize:12,color:C.inkLight,marginBottom:16}}>{editingQ.title}</div>
            {tempQuestions.map((q,qi)=>(
              <div key={qi} style={{background:C.surface,borderRadius:10,padding:"14px",marginBottom:12}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                  <span style={{fontSize:12,fontWeight:600,color:C.ink}}>Question {qi+1}</span>
                  <button onClick={()=>setTempQuestions(qs=>qs.filter((_,i)=>i!==qi))} style={{...S.btnDanger,padding:"2px 8px"}}>Remove</button>
                </div>
                <div style={S.fg}><input style={S.input} value={q.q} onChange={e=>updateQ(qi,"q",e.target.value)} placeholder="Question text"/></div>
                {q.opts.map((opt,oi)=>(
                  <div key={oi} style={{display:"flex",gap:8,marginBottom:6,alignItems:"center"}}>
                    <input type="radio" name={`correct-${qi}`} checked={q.answer===oi} onChange={()=>updateQ(qi,"answer",oi)} style={{accentColor:C.teal}}/>
                    <input style={{...S.input,fontSize:12}} value={opt} onChange={e=>updateOpt(qi,oi,e.target.value)} placeholder={`Option ${oi+1}`}/>
                    <span style={{fontSize:10,color:q.answer===oi?C.teal:C.inkLight,flexShrink:0}}>{q.answer===oi?"Correct":""}</span>
                  </div>
                ))}
              </div>
            ))}
            <button style={S.btnGhost} onClick={addQuestion}>+ Add question</button>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:16}}>
              <button style={S.btnSecondary} onClick={()=>setEditingQ(null)}>Cancel</button>
              <button style={S.btnPrimary} onClick={saveQuestions}>Save questions</button>
            </div>
          </div>
        </div>
      )}

      {/* Certificate viewer */}
      {viewCert && <CertificateDoc cert={viewCert} onClose={()=>setViewCert(null)}/>}

      {/* Tabs */}
      <div style={{display:"flex",gap:6,marginBottom:16}}>
        {[["videos","Training videos"],["certificates","Certificates issued"],["notifications","Notifications"],["settings","Program settings"]].map(([k,l])=>(
          <button key={k} onClick={()=>setTab(k)} style={{padding:"6px 14px",borderRadius:7,border:`1px solid ${tab===k?C.blue:C.border}`,background:tab===k?C.blueLight:C.white,color:tab===k?C.blue:C.inkMid,fontSize:12,cursor:"pointer",position:"relative"}}>
            {l}
            {k==="notifications"&&unread>0&&<span style={{position:"absolute",top:-4,right:-4,background:"#EF4444",color:C.white,fontSize:9,fontWeight:600,padding:"1px 5px",borderRadius:8}}>{unread}</span>}
          </button>
        ))}
      </div>

      {/* -VIDEOS TAB -*/}
      {tab==="videos" && (
        <div>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:14}}>
            <span style={{fontSize:14,fontWeight:600,color:C.ink}}>Certification videos ({videos.length})</span>
            <button style={S.btnPrimary} onClick={openAddVideo}>+ Add video</button>
          </div>
          {["tech","advisor"].map(track=>(
            <div key={track} style={{marginBottom:20}}>
              <div style={{fontSize:12,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8,padding:"6px 18px",background:track==="tech"?C.tealLight:C.blueLight,borderRadius:8,display:"inline-block"}}>
                {track==="tech"?"Technician track -How to use products":"Service advisor track -How to sell"}
              </div>
              <div style={S.card}>
                {videos.filter(v=>v.track===track).map(v=>(
                  <div key={v.id} style={{padding:"14px 18px",borderBottom:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",marginBottom:8}}>
                      <div>
                        <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:2}}>{v.title}</div>
                        <div style={{fontSize:11,color:C.inkLight}}>
                          {v.duration} . {v.questions.length} questions . {v.required?"Required":"Optional"}
                          {v.videoUrl&&<span> . <span style={{color:C.teal}}>Video linked</span></span>}
                        </div>
                      </div>
                      <div style={{display:"flex",gap:6,alignItems:"center"}}>
                        <span style={v.active?S.pillGreen:{...S.pillRed}}>{v.active?"Active":"Off"}</span>
                        <button style={S.btnSmall} onClick={()=>openEditVideo(v)}>Edit</button>
                        <button style={S.btnSmall} onClick={()=>startEditQuestions(v)}>Questions</button>
                        <button style={v.active?S.btnDanger:S.btnSuccess} onClick={()=>setVideos(vs=>vs.map(x=>x.id===v.id?{...x,active:!x.active}:x))}>{v.active?"Off":"On"}</button>
                        <button style={S.btnDanger} onClick={()=>setVideos(vs=>vs.filter(x=>x.id!==v.id))}>x</button>
                      </div>
                    </div>
                    <div style={{fontSize:12,color:C.inkMid}}>{v.desc}</div>
                  </div>
                ))}
                {videos.filter(v=>v.track===track).length===0&&<div style={{padding:20,textAlign:"center",color:C.inkLight,fontSize:12}}>No videos in this track yet</div>}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* -CERTIFICATES TAB -*/}
      {tab==="certificates" && (
        <div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
            {[
              {l:"Total issued",v:certs.length},
              {l:"Pending mail",v:certs.filter(c=>c.status==="pending_mail").length,warn:true},
              {l:"Shipped",v:certs.filter(c=>c.status==="shipped").length},
              {l:"Technician certs",v:certs.filter(c=>c.track==="tech").length},
            ].map(m=>(
              <div key={m.l} style={{background:C.white,border:`1px solid ${m.warn&&m.v>0?C.amber:C.border}`,borderRadius:10,padding:"12px 16px"}}>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:3}}>{m.l}</div>
                <div style={{fontSize:20,fontWeight:600,color:m.warn&&m.v>0?C.amber:C.ink}}>{m.v}</div>
              </div>
            ))}
          </div>

          {certs.filter(c=>c.status==="pending_mail").length>0 && (
            <div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:10,padding:"12px 16px",marginBottom:16}}>
              <div style={{fontSize:13,fontWeight:600,color:C.amber,marginBottom:4}}>Certificates to print & ship</div>
              {certs.filter(c=>c.status==="pending_mail").map(c=>(
                <div key={c.certNum} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:`1px solid rgba(180,83,9,0.15)`}}>
                  <div style={{fontSize:12,color:C.amber}}><strong>{c.name}</strong> -{c.shop} -{c.certNum} ({c.track==="tech"?"Technician":"Service Advisor"})</div>
                  <div style={{display:"flex",gap:6}}>
                    <button style={S.btnSmall} onClick={()=>setViewCert({...c,shopName:c.shop})}>View</button>
                    <button style={S.btnSuccess} onClick={()=>markShipped(c.certNum)}>Mark shipped</button>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={S.card}>
            <div style={{display:"grid",gridTemplateColumns:"140px 1fr 130px 100px 50px 70px 80px 100px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
              <span>Certificate #</span><span>Name</span><span>Shop</span><span>Category</span><span>Score</span><span>Date</span><span>Status</span><span></span>
            </div>
            {certs.map(c=>(
              <div key={c.certNum} style={{display:"grid",gridTemplateColumns:"140px 1fr 130px 100px 50px 70px 80px 100px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                <span style={{fontWeight:600,color:C.blue,fontSize:11,cursor:"pointer",textDecoration:"underline"}} onClick={()=>setViewCert({...c,shopName:c.shop})}>{c.certNum}</span>
                <span style={{fontWeight:500,color:C.ink}}>{c.name}</span>
                <span style={{color:C.inkLight,fontSize:11}}>{c.shop}</span>
                <span style={c.track==="tech"?S.pillGreen:S.pillBlue}>{c.track==="tech"?"Technician":"Svc Advisor"}</span>
                <span style={{color:C.teal,fontWeight:500}}>{c.score}%</span>
                <span style={{color:C.inkLight,fontSize:11}}>{c.date}</span>
                <span style={c.status==="issued"?S.pillGreen:c.status==="shipped"?{...S.pillBlue}:S.pillAmber}>
                  {c.status==="issued"?"Issued":c.status==="shipped"?"Shipped":"Mail pending"}
                </span>
                <div style={{display:"flex",gap:4}}>
                  <button style={S.btnSmall} onClick={()=>setViewCert({...c,shopName:c.shop})}>View</button>
                  {c.status==="pending_mail"&&<button style={S.btnSuccess} onClick={()=>markShipped(c.certNum)}>Ship</button>}
                  {c.status==="shipped"&&<button style={S.btnSmall} onClick={()=>markIssued(c.certNum)}>Done</button>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* -NOTIFICATIONS TAB -*/}
      {tab==="notifications" && (
        <div>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:14}}>
            <span style={{fontSize:14,fontWeight:600,color:C.ink}}>Certification notifications ({notifications.length})</span>
            {unread>0&&<button style={S.btnSmall} onClick={()=>setNotifications(ns=>ns.map(n=>({...n,read:true})))}>Mark all read</button>}
          </div>
          <div style={S.card}>
            {notifications.length===0&&<div style={{padding:20,textAlign:"center",color:C.inkLight,fontSize:12}}>No notifications yet</div>}
            {notifications.map(n=>(
              <div key={n.id} style={{padding:"12px 18px",borderBottom:`1px solid ${C.border}`,background:n.read?"transparent":C.blueLight,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{fontSize:12,color:C.ink,fontWeight:n.read?400:600}}>
                    {n.type==="cert_completed"&&<span style={{color:C.teal,marginRight:6}}>NEW CERT</span>}
                    {n.type==="cert_shipped"&&<span style={{color:C.blue,marginRight:6}}>SHIPPED</span>}
                    {n.type==="reminder_sent"&&<span style={{color:C.amber,marginRight:6}}>REMINDER</span>}
                    {n.text}
                  </div>
                  <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>{n.date}</div>
                </div>
                {!n.read&&<button style={S.btnSmall} onClick={()=>setNotifications(ns=>ns.map(x=>x.id===n.id?{...x,read:true}:x))}>Read</button>}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* -SETTINGS TAB -*/}
      {tab==="settings" && (
        <div style={S.card}>
          <div style={S.cardHdr}><span style={S.cardTitle}>Program settings</span></div>
          <div style={{padding:"20px 24px"}}>
            <div style={S.twoCol}>
              <div style={S.fg}><label style={S.label}>Minimum pass score (%)</label><input style={S.input} type="number" value={settings.passScore} onChange={e=>setSettings(s=>({...s,passScore:parseInt(e.target.value)||70}))} min={50} max={100}/></div>
              <div style={S.fg}><label style={S.label}>Questions per video</label><input style={S.input} type="number" value={settings.questionsPerVideo} onChange={e=>setSettings(s=>({...s,questionsPerVideo:parseInt(e.target.value)||5}))} min={3} max={20}/></div>
            </div>
            <div style={S.twoCol}>
              <div style={S.fg}><label style={S.label}>Retakes allowed</label><select style={S.select} value={settings.retakes} onChange={e=>setSettings(s=>({...s,retakes:e.target.value}))}><option>Unlimited</option><option>3 attempts</option><option>1 attempt</option></select></div>
              <div style={S.fg}><label style={S.label}>Certificate validity</label><select style={S.select} value={settings.validity} onChange={e=>setSettings(s=>({...s,validity:e.target.value}))}><option>No expiry</option><option>1 year</option><option>2 years</option></select></div>
            </div>
            <div style={S.fg}><label style={S.label}>Notification email for new certificates</label><input style={S.input} value={settings.notifyEmail} onChange={e=>setSettings(s=>({...s,notifyEmail:e.target.value}))}/></div>
            <div style={{background:C.blueLight,borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1D4ED8",marginBottom:16}}>
              When a technician or service advisor completes certification, you'll be notified here and via email. You'll also be alerted when certificates need to be printed and shipped.
            </div>
            <button style={S.btnPrimary} onClick={()=>alert("Settings saved!")}>Save settings</button>
          </div>
        </div>
      )}
    </div>
  );
}

export { INIT_CERT_VIDEOS, INIT_TECHNICIANS, CertificateDoc, QuizEngine };

export default ShopCertification;